import { Controller } from '@hotwired/stimulus';

export default class extends Controller {
    connect() {
        const element = this.element;
        this.multiple = element.dataset.multiple;
        this.default_text = element.dataset.defaulttext;
        this.click_redirect = element.dataset.clickredirect;
        this.select = element.querySelector('select');

        this.wrapSelect();
        this.buildSelect();
    }

    buildSelect() {
        const element = this.element;
        this.selected = element.querySelector(".selected");
        const selectedText = [];
        let html = '';

        this.select.querySelectorAll("option").forEach((option) => {
            const value = option.getAttribute("value");
            const selectedAttr = option.hasAttribute("selected") ? `data-selected="true"` : '';
            let name = option.innerText;
            let title = name;
            title = title.replace('(', '<span class="details">');
            title = title.replace(')', '</span>');
            name = name.replace(/\((.+?)\)/gu, "");
            if (this.multiple) {
                const color = option.getAttribute("data-color");
                const selected = option.hasAttribute("selected");
                html += `<li data-value="${value}" data-name="${name}" ${selectedAttr}>
                         <label>
                         <span class="checkbox-container" style="--color: ${color}">
                         <input type="checkbox" ${selected ? 'checked' : ''}/>
                         <span class="checkmark"></span>
                         ${title}
                         </span>
                         </label>
                         </li>`;
            } else {
                html += `<li data-value="${value}" data-name="${name}" ${selectedAttr}>${title}</li>`;
            }
        });

        const ul = element.querySelector("ul.select-dropdown");
        ul.insertAdjacentHTML("afterbegin", html);

        document.addEventListener("click", (e) => {
            if (!element.querySelector(".js-select").contains(e.target)) {
                ul.style.display = "none";
                element.querySelector(".js-select").classList.remove('select-open');
            }
        });

        this.select.addEventListener('reset', () => {
            this.resetSelection();
        });

        for (let i = 0; i < this.select.options.length; i++) {
            if (this.select.options[i].hasAttribute("selected")) {
                const name = this.select.options[i].text.replace(/\((.+?)\)/gu, "");
                selectedText.push(name);
            }
        }

        this.selected.innerHTML = selectedText.length > 0 ? selectedText.join(', ') : this.default_text;
        this.selected.addEventListener("click", function () {
            element.querySelector("ul.select-dropdown").style.display = "block";
            element.querySelector(".js-select").classList.add('select-open');
        });

        if (this.multiple) {
            this.selected.querySelectorAll("span").forEach((span) => {
                span.addEventListener("click", () => {
                    const value = span.getAttribute("data-value");
                    element.querySelector(`input[name="${value}"]`).checked = false;
                    this.updateData();
                });
            });
        }

        element.querySelectorAll("ul.select-dropdown li").forEach((li) => {
            li.addEventListener("click", () => {
                if (this.multiple) {
                    this.updateData();
                } else {
                    this.select.value = li.getAttribute("data-value");
                    this.selected.innerHTML = li.getAttribute("data-name");
                    if (this.click_redirect) {
                        location.href = this.select.value;
                    }
                }

                this.select.dispatchEvent(new Event('change'));
                element.querySelector("ul.select-dropdown").style.display = "none";
                element.querySelector(".js-select").classList.remove('select-open');

                const form = element.closest('form');
                if (form) {
                    form.submit();
                }
            });
        });
    }

    updateData() {
        let selectedNames = [];
        const selectedValues = [];

        this.element.querySelectorAll("ul.select-dropdown li").forEach((li) => {
            const checkbox = li.querySelector("input[type='checkbox']");
            if (checkbox && checkbox.checked) {
                selectedNames.push(li.getAttribute("data-name"));
                selectedValues.push(li.getAttribute("data-value"));
            }
        });

        for (let i = 0; i < this.select.options.length; i++) {
            const value = this.select.options[i].value;
            if (value) {
                this.select.options[i].selected = selectedValues.indexOf(value) >= 0;
            }
        }

        selectedNames = selectedNames ? selectedNames.join(", ") : '';
        this.selected.innerHTML = selectedNames ? selectedNames : this.default_text;
    }

    resetSelection() {
        this.selected.innerHTML = this.default_text;
        this.select.selectedIndex = -1;
        this.select.dispatchEvent(new CustomEvent('change'));
        const form = this.element.closest('form');
        if (form) {
            form.submit();
        }
    }

    wrapSelect() {
        const wrapper = document.createElement('div');
        wrapper.classList = 'js-select';
        this.select.parentNode.insertBefore(wrapper, this.select);
        wrapper.appendChild(this.select);
        this.select.insertAdjacentHTML("afterend", '<ul class="select-dropdown"></ul>');
        this.select.insertAdjacentHTML("beforebegin", '<div class="selected"></div>');
    }
}
